function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.1,
  cx: 41,
  cy: 41,
  r: 41,
  fill: "#4293F6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62 37.812V52.7477C61.8808 53.1294 61.7955 53.5273 61.6358 53.8895C60.7313 55.9366 59.165 56.9366 57.0497 56.9816C55.4244 57.0162 53.7969 56.9896 52.1716 56.9896H25.1155C23.3338 56.9896 21.8692 56.3115 20.8148 54.7579C20.4025 54.1513 20.1816 53.4581 20 52.7477V37.812C20.1859 37.7798 20.3467 37.872 20.513 37.9274C26.8742 40.1571 33.2344 42.3869 39.5934 44.6167C40.4892 44.9476 41.4642 44.9524 42.3628 44.6305C48.6708 42.4154 54.9807 40.2048 61.2923 37.9989C61.5231 37.9216 61.7441 37.7936 62 37.812Z",
  fill: "#2F66E3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62 29.7847V34.9643C61.8305 35.0185 61.6587 35.0681 61.4914 35.127C54.9391 37.4244 48.3868 39.7238 41.8345 42.025C41.3281 42.2038 40.8502 42.2718 40.3241 42.0827C35.9381 40.5272 31.5482 38.9845 27.1542 37.4544C24.7713 36.6201 22.3866 35.7901 20 34.9643V29.7847C20.0405 29.6475 20.0831 29.5102 20.1192 29.3718C20.2831 28.7001 20.5768 28.0712 20.9821 27.5249C21.3873 26.9785 21.8952 26.5263 22.4741 26.1967C23.267 25.7273 24.1322 25.5439 25.0345 25.5428H33.3591C33.9114 25.5428 33.93 25.5186 33.9333 24.9269C33.9333 24.5671 33.9333 24.2072 33.9333 23.8485C33.9978 21.6411 35.4547 20.0668 37.5514 20.0299C39.8483 19.9895 42.1452 19.9953 44.442 20.0299C46.2052 20.0552 47.5745 21.2293 47.9541 22.9512C48.0908 23.5729 48.0634 24.2084 48.0634 24.8416C48.0634 25.5416 48.0634 25.5428 48.7197 25.5428C51.4945 25.5428 54.2705 25.5174 57.0442 25.552C59.1617 25.5797 60.728 26.59 61.638 28.6429C61.7966 29.0005 61.8808 29.403 62 29.7847ZM40.9573 25.5405C41.7634 25.5405 42.5695 25.5405 43.3756 25.5405C44.5623 25.5313 44.4278 25.6962 44.4322 24.3998C44.4322 23.8739 44.3983 23.8405 43.8853 23.8393C42.1506 23.8393 40.4159 23.8312 38.6812 23.8393C37.4169 23.8462 37.5788 23.6467 37.558 25.0434C37.5514 25.4194 37.6958 25.5497 38.0447 25.5439C39.0181 25.5324 39.9883 25.5405 40.9573 25.5405Z",
  fill: "#2F66E3"
});

var SvgProdClaim = function SvgProdClaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProdClaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prod_claim.11835438.svg";
export { ForwardRef as ReactComponent };